const skillsArray = [
  {
    image: "./Images/Skills/skill-1.png",
    skillName:[ "Native Android Developer"],
    tools: ["XMI", "Java", "Firbase"],
  },
  {
    image: "./Images/Skills/skill-2.png",
    skillName: "Flutter App developer",
    tools: ["VS Code", "Flutter", "Dartt", "Firebase"],
  },
  {
    image: "./Images/Skills/skill-3.jpg",
    skillName: "Web Developer",
    tools: ["ReactJS", "HTML", "CSS", "JavaScript"],
  },
  {
    image: "./Images/Skills/skill-4.jpg",
    skillName: "IOS Development in flutter",
    tools: ["VS Code", "Xcode", "Dartt", "Getx", "MVC"],
  },
  {
    image: "./Images/Skills/skill-5.png",
    skillName: "Web App using flutter",
    tools: ["VS Code", "Xcode", "Dartt", "Getx", "MVC"],
  }
];
export default skillsArray;
